var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx } from "react/jsx-runtime";
import { BaseVolumeTable } from '../common/baseTable';
import { TableComponent } from '../common/tableComponent';
import { QueueStatusType } from '../queue/types';
export var AttritionContent = function () {
    return _jsx(BaseVolumeTable, { name: "attrition", decimal: 2, min: 0, max: 99.99, suffix: "%" });
};
export var AttritionStep = function () {
    return (_jsx(TableComponent, __assign({ name: "attrition", statusType: QueueStatusType.Attrition }, { children: _jsx(AttritionContent, {}) })));
};
